import PGSHelper from "../helpers/PGSHelper.js";
import store from "../store";
import { merge } from "lodash";

import FirebaseConfig from "../helpers/FirebaseConfig.js";
const firebaseConf = new FirebaseConfig();
export default class Permisos {
  universalDepartment = "UNI__";
  constructor(role) {
    this.Role = role;
  }

  roleBlock = [
    {
      MYT_Mayorista: {
        UNI__: ["V"],
      },
      MYT_UsuarioMayorista: {
        UNI__: ["C"],
      },
      PDV_Productos: {
        ProShop: ["C", "M"],
      },
      RVA_Mayoristas: {
        UNI__: ["M"],
      },
      RVA_TeeSheet: {
        Golf: ["V", "C", "M"],
        TopTracer: ["V", "C", "C"],
      },
    },
    {
      MYT_Mayorista: {
        UNI__: ["V"],
      },
      MYT_UsuarioMayorista: {
        UNI__: ["E"],
      },
      PDV_Productos: {
        ProShop: ["E", "V"],
      },
      RVA_Mayoristas: {
        UNI__: [],
      },
      RVA_TeeSheet: {
        Golf: [],
        TopTracer: [],
      },
    },
  ];

  patch = {
    RVA_Mayoristas: {
      UNI__: ["C", "V"],
    },
  };

  getMenu(typeUser = "Admin", params = { MayoristaAdmin: false }) {
    if (params.MayoristaAdmin) {
      typeUser = "MayoristaAdmin";
    }
    let menu = [
      {
        id: "RVA_Home",
        title: "Dashboard",
        icon: "mdi-home",
        route: "/",
        universal: true,
        access: ["Admin", "Reservas", "ReportesCaja", "SuperAdmin", "AYBAdmin", "Actividades"],
        type: "link",
      },
      {
        id: "RVA_TeeSheet",
        title: "Tee Sheet",
        icon: "mdi-calendar",
        route: "/booking",
        universal: true,
        access: ["Admin", "Reservas", "ReportesCaja", "SuperAdmin"],
        /*routeOptions: {
          Golf: "/booking",
          TopTracer: "/booking"
        },*/
        type: "link",
      },
      {
        id: "teeSheet",
        title: "Tee Sheet ",
        icon: "mdi-calendar",
        route: "/bookingMayorista",
        type: "link",
        access: ["Mayorista", "MayoristaAdmin",],
        public: true,
      },
      {
        id: "RVA_TeeSheetActivityV2",
        title: "Tee Sheet Actividades V2",
        icon: "mdi-calendar",
        route: "/actividadesV2",
        universal: true,
        type: "link",
        access: ["Admin", "AYBAdmin", "Actividades", "SuperAdmin"],
      },
      /*{
        id: "RVA_TeeSheetActivity",
        title: " T̶e̶e̶ ̶S̶h̶e̶e̶t̶ ̶A̶c̶t̶i̶v̶i̶d̶a̶d̶e̶s̶",
        icon: "mdi-calendar",
        route: "/actividades",
        universal: true,
        type: "link",
        access: ["Admin", "AYBAdmin", "Actividades", "SuperAdmin"],
      },*/
      {
        id: "RVA_LIST_RESERVA",
        title: "Lista de reservas",
        icon: "mdi-clipboard-list",
        route: "/list_reserva",
        universal: true,
        type: "link",
        access: ["Admin", "SuperAdmin"],
      },
      {
        id: "tarifas",
        title: "Tarifas",
        icon: "mdi-currency-usd",
        route: "/tarifas",
        type: "link",
        access: ["Admin", "SuperAdmin"],
        childs: [
          {
            id: "RVA_Mayoristas_TARIFA",
            title: "Agencias",
            icon: "mdi-domain",
            universal: true,
            route: "/mayoristas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_SUBCATEGORIAS",
            title: "Nombres de tarifa",
            icon: "mdi-clipboard-list",
            route: "/tarifas/subcategorias",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_TEMPORADAS",
            title: "Temporadas",
            icon: "mdi-calendar",
            route: "/tarifas/temporadas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_HORARIOS",
            title: "Horarios",
            icon: "mdi-alarm",
            route: "/tarifas/horarios",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_TARIFARIOS",
            title: "Tarifarios",
            icon: "mdi-view-list",
            route: "/tarifas/tarifarios",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_TARIFAS",
            title: "Administrador de Tarifas",
            icon: "mdi-currency-usd",
            route: "/tarifas/creator",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "RVA_MERCADOS_RESERVA",
            title: "Mercados de Reserva",
            icon: "mdi-view-list",
            route: "/tarifas/mercados",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },

        ],
      },
      {
        id: "tarifas-act",
        title: "Tarifas Actividades V2",
        icon: "mdi-currency-usd",
        route: "/tarifas-actividades",
        type: "link",
        access: ["Admin", "SuperAdmin"],
        childs: [
          {
            id: "ACT_TARIFAS",
            title: "Horarios y precios V2",
            icon: "mdi-currency-usd",
            route: "/tarifas/timesCreator",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "ACT_PAQUETES_PRECIOS",
            title: "Paquetes de precios V2",
            icon: "mdi-currency-usd",
            route: "/tarifas/paquetesCreator",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
        ],
      },
      /*{
        type: "divider",
      },*/
      {
        id: "clientes",
        title: "Clientes",
        icon: "mdi-account-multiple-outline",
        route: "/clientes",
        type: "link",
        access: ["Admin", "AYBAdmin", "Cajero", "SuperAdmin", "Monederos"],
        childs: [
          {
            id: "CTS_CLIENTES",
            title: "Clientes",
            icon: "mdi-account-multiple-outline",
            route: "/clientes/lista_cliente",
            universal: true,
            type: "link",
            access: ["Admin", "Cajero", "SuperAdmin"],
          },
          {
            id: "CTS_GRUPOS",
            title: "Grupos clientes",
            icon: "mdi-account-box-outline",
            route: "/clientes/grupos_cliente",
            universal: true,
            type: "link",
            access: ["Admin", "SuperAdmin", "Cajero"],
          },
          {
            id: "CTS_CUENTAS",
            title: "CXC",
            icon: "mdi-wallet-outline",
            route: "/clientes/cuentas",
            universal: true,
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin", "Cajero"],
          },
          {
            id: "CTS_MONEDERO",
            title: "Monedero",
            icon: "mdi-credit-card",
            route: "/clientes/monedero",
            universal: true,
            type: "link",
            access: ["Admin", "SuperAdmin", "Cajero", "Monederos"],
          },
        ],
      },
      {
        id: "membresias",
        title: "Membresias",
        icon: "mdi-account-star",
        route: "/membresias",
        type: "link",
        access: ["Admin", "Cajero", "SuperAdmin"],
        childs: [
          {
            id: "MBS_PLANES_MEMBRESIAS",
            title: "Planes Membresias",
            icon: "mdi-format-list-checkbox",
            route: "/membresias/planes",
            universal: true,
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_MEMBRESIAS",
            title: "Membresias",
            icon: "mdi-star-circle",
            route: "/membresias/listadoMembresias",
            universal: true,
            type: "link",
            access: ["Admin", "Cajero", "SuperAdmin"],
          },
          {
            id: "MBS_MIEMBROS",
            title: "Miembros",
            icon: "mdi-account-star",
            universal: true,
            route: "/membresias/miembros",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_PERIODOS_COBRO",
            title: "Periodos Cobro",
            universal: true,
            route: "/membresias/periodos-cobro",
            type: "link",
            icon: "mdi-currency-usd",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_CONCEPTOS",
            title: "Conceptos",
            universal: true,
            route: "/membresias/conceptos",
            type: "link",
            icon: "mdi-format-list-checkbox",
            access: ["Admin", "SuperAdmin"],
          },
          /*{
            id: "MBS_CREDITBOOK",
            title: "CreditBook",
            universal: true,
            route: "/membresias/creditbook",
            type: "link",
            icon: "mdi-wallet",
            access: ["Admin", "SuperAdmin"],
          },*/
          {
            id: "MBS_IMPORTADOR",
            title: "Importar pagos",
            universal: true,
            route: "/importador",
            type: "link",
            icon: "mdi-format-list-checkbox",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_FILTRO_SEGURIDAD",
            title: "Filtro Acceso",
            icon: "mdi-security",
            universal: true,
            route: "/membresias/security-filter",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_CARGAR_MOVIMIENTOS",
            universal: true,
            title: "Cargar movimientos",
            icon: "mdi-plus-box",
            route: "/membresias/load-movimientos",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_MOVIMIENTOS",
            universal: true,
            title: "Reporte de movimientos",
            icon: "mdi-file-document",
            route: "/membresias/movimientos",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "MBS_REPORTE_PLANES",
            universal: true,
            title: "Reporte de planes",
            icon: "mdi-file-document",
            route: "/membresias/reporte-planes",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          /*{
            id: "MBS_PLANES_MBR",
            universal: true,
            title: "Planes CB",
            icon: "mdi-wallet",
            route: "/membresias/planes-mbr",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },*/
        ],
      },
      /*{
        id: 'lineasCredito',
        title: "Crédito",
        icon: "mdi-credit-card-outline",
        route: "/credito",
        type: "link",
        childs: [
          {
            id: 'LC_Lineas',
            title: "Lineas de Crédito",
            icon: "mdi-credit-card-outline",
            route: "/credito/lineas",
            universal: true,
            type: "link",
          },
          {
            id: 'LC_TiposLineas',
            title: "Tipos lineas de crédito",
            icon: "mdi-format-list-checkbox",
            route: "/credito/tipos-lineas",
            universal: true,
            type: "link",
          },
        ]
      },*/
      {
        id: "mayoristaUser",
        title: "Usuarios Agencia",
        icon: "mdi-account",
        route: "/userMayorista",
        type: "link",
        access: ["MayoristaAdmin"],
        public: true,
      },
      {
        id: "usuarios",
        title: "Usuarios",
        icon: "mdi-account-supervisor-circle",
        route: "/usuarios_admin",
        type: "link",
        access: ["Admin", "SuperAdmin"],
        childs: [
          {
            id: "USR_USER",
            title: "Cajeros",
            universal: true,
            icon: "mdi-account-multiple-outline",
            route: "/usuarios_admin/cajeros",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "USR_USER_ADMIN",
            title: "Administrativos",
            universal: true,
            icon: "mdi-account-multiple-outline",
            route: "/usuarios_admin/administrativos",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
        ],
      },
      {
        id: "restaurante",
        title: "Restaurante",
        icon: "mdi-silverware-fork-knife",
        route: "/restaurante_admin",
        type: "link",
        access: ["Admin", "AYBAdmin", "ReservasAyB", "SuperAdmin"],
        childs: [
          {
            id: "AYB_Departamentos",
            title: "Areas",
            universal: true,
            icon: "mdi-table-chair",
            route: "/restaurante/departamentos",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB-Monederos-restaurante",
            title: "Monederos Ayb",
            icon: "mdi-wallet-outline",
            universal: true,
            route: "/restaurante/monederos-fb",
            access: ["AYBAdmin", "SuperAdmin"],
            type: "link",
          },
          {
            id: "AYB_Meseros",
            title: "Meseros",
            universal: true,
            icon: "mdi-account-multiple",
            route: "/restaurante/meseros",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },

          {
            id: "PROD_PROVEEDORES",
            title: "Proveedores",
            icon: "mdi-account-arrow-left",
            universal: true,
            route: "/productos-inventarios/proveedores",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_Cuentas",
            title: "Cuentas Mesa",
            universal: true,
            icon: "mdi-silverware-fork-knife",
            route: "/restaurante/cuentas",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "Admin_Mesas",
            title: "Admin Mesas",
            universal: true,
            icon: "mdi-shield",
            route: "/restaurante/mesas-cuentas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "AYB_Reservas",
            title: "Reservas AYB",
            universal: true,
            icon: "mdi-calendar",
            route: "/restaurante/reservas",
            type: "link",
            access: ["Admin", "AYBAdmin", "ReservasAyB", "SuperAdmin"],
          },
          {
            id: "AYB_Productos",
            title: "Recetas AYB",
            universal: true,
            icon: "mdi-food",
            route: "/restaurante/productos-ayb",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_Insumos",
            title: "Insumos AYB",
            universal: true,
            icon: "mdi-food-apple",
            route: "/restaurante/insumos-ayb",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_InsumosC",
            title: "Subreceta AYB",
            universal: true,
            icon: "mdi-soy-sauce",
            route: "/restaurante/insumosC-ayb",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "INV_OrdenCompraInsumo",
            title: "Ordenes de Compra Insumos",
            universal: true,
            icon: "mdi-cart-plus",
            route: "/productos-inventarios/orden-compra-insumo",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "INV_OrdenCompraPresentacion",
            title: "Ordenes de Compra Presentaciones",
            universal: true,
            icon: "mdi-cart-plus",
            route: "/productos-inventarios/orden-compra-presentacion",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "INV_OrdenCompraIdeales",
            title: "Ordenes Generadas Desde Existencia Ideal",
            universal: true,
            icon: "mdi-cart-plus",
            route: "/productos-inventarios/orden-compra-ideales",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_Compras",
            title: "Compras",
            universal: true,
            icon: "mdi-shopping",
            route: "/productos-inventarios/compras",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_produccion",
            title: "Produccion de insumos",
            universal: true,
            icon: "mdi-package-up",
            route: "/restaurante/produccion-ayb",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "AYB_eventos",
            title: "Eventos",
            universal: true,
            icon: "mdi-calendar",
            route: "/restaurante/eventos",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "Traduccion_Menu",
            title: "Traduccion Menu",
            universal: true,
            icon: "mdi-alphabet-latin",
            route: "/restaurante/traduccion-productos",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
        ],
      },
      {
        id: "mayoristas",
        title: "Agencias",
        icon: "mdi-domain",
        route: "/mayoristas",
        type: "link",
        access: ["Admin", "ReportesCaja", "SuperAdmin"],
        childs: [
          {
            id: "RVA_Mayoristas",
            title: "Agencias",
            icon: "mdi-domain",
            universal: true,
            route: "/mayoristas",
            type: "link",
            access: ["Admin", "ReportesCaja", "SuperAdmin"],
          },
          {
            id: "RVA_Concierges",
            title: "Concierges",
            icon: "mdi-domain",
            universal: true,
            route: "/mayoristas/concierges",
            type: "link",
            access: ["Admin", "ReportesCaja", "SuperAdmin"],
          },
          {
            id: "RVA_UsuarioMayorista",
            title: "Usuarios",
            icon: "mdi-account-multiple-outline",
            universal: true,
            route: "/mayoristas/usuarios",
            type: "link",
            access: ["Admin", "ReportesCaja", "SuperAdmin"],
          },
          /*{
            id: 'MYT_TRANSPORTACION',
            title: "Costos de transportación",
            icon: "mdi-currency-usd",
            universal: true,
            route: "/mayoristas/transportacion",
            type: "link",
          },*/
          /*{
            id: 'MYT_CUPONES',
            title: "Cupones",
            universal: true,
            icon: "mdi-ticket-confirmation",
            route: "/mayoristas/cupones",
            type: "link",
          },*/
        ],
      },
      {
        id: "productos_inventarios",
        title: "Productos e Inventarios",
        icon: "mdi-package-variant-closed",
        route: "/productos-inventarios",
        type: "link",
        access: ["Admin", "AYBAdmin", "Almacen", "SuperAdmin"],
        childs: [
          {
            id: "PROD_FAMILIAS",
            title: "Familias productos",
            icon: "mdi-home-group",
            route: "/productos-inventarios/familias",
            universal: true,
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "PROD_CATEGORIAS",
            title: "Categorias Productos",
            icon: "mdi-format-list-bulleted-type",
            route: "/productos-inventarios/categorias",
            universal: true,
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PDV_Productos",
            title: "Productos",
            icon: "mdi-cart",
            universal: true,
            route: "/productos-inventarios/productos",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PROD_SERVICIOS",
            title: "Servicios",
            universal: true,
            icon: "mdi-toolbox-outline",
            route: "/productos-inventarios/servicios",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PDV_CODIGOS_BARRA",
            title: "Codigos de barra",
            icon: "mdi-barcode",
            universal: true,
            route: "/productos-inventarios/codigos-barra",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "PDV_Modificadores",
            title: "Modificadores",
            icon: "mdi-clipboard-list",
            universal: true,
            route: "/productos-inventarios/modificadores",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PROD_PROMOCIONES",
            title: "Promociones",
            icon: "mdi-percent",
            universal: true,
            route: "/productos-inventarios/promociones",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "PROD_CC",
            title: "Almacenes",
            icon: "mdi-package-variant-closed",
            universal: true,
            route: "/productos-inventarios/inventarios",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PROD_PROVEEDORES",
            title: "Proveedores",
            icon: "mdi-account-arrow-left",
            universal: true,
            route: "/productos-inventarios/proveedores",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "PROD_RECEPCION_MERCANCIAS",
            title: "Recepción de mercancias",
            icon: "mdi-cart-arrow-down",
            universal: true,
            route: "/productos-inventarios/entradas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "PROD_SALIDAS_MERCANCIAS",
            title: "Salidas de mercancias",
            icon: "mdi-cart-arrow-up",
            universal: true,
            route: "/productos-inventarios/salidas",
            type: "link",
            access: ["Admin", "AYBAdmin", "Almacen", "SuperAdmin"],
          },
          {
            id: "PROD_REPORTE_INV",
            title: "Reporte de Existencias",
            icon: "mdi-file-document",
            universal: true,
            route: "/productos-inventarios/reporteExistencias",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },

          {
            id: "PROD_TRANSFERENCIA_MERCANCIAS",
            title: "Transferencia de mercancias",
            icon: "mdi-swap-horizontal-bold",
            universal: true,
            route: "/productos-inventarios/transferencias",
            type: "link",
            access: ["Admin", "AYBAdmin", "Almacen", "SuperAdmin"],
          },
          {
            id: "PROD_AJUSTE_STOCK",
            title: "Ajuste de Inventarios",
            icon: "mdi-swap-horizontal-bold",
            universal: true,
            route: "/productos-inventarios/conteo-rapido",
            type: "link",
            access: ["Admin", "AYBAdmin", "Almacen", "SuperAdmin"],
          },
          {
            id: "conteo_inventarios",
            title: "Conteo de inventarios",
            icon: "mdi-calculator",
            universal: true,
            route: "/productos-inventarios/conteoMercancias",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
          {
            id: "consumo_promedio",
            title: "Consumo promedio",
            icon: "mdi-chart-line",
            universal: true,
            route: "/productos-inventarios/consumoPromedio",
            type: "link",
            access: ["Admin", "AYBAdmin", "SuperAdmin"],
          },
        ],
      },
      {
        id: "RVA_RONDAS",
        title: "Rondas Prepago",
        icon: "mdi-view-list",
        universal: true,
        route: "/rondas-prepago",
        type: "link",
        access: ["Admin", "SuperAdmin"],
      },
      {
        id: "TRANSPORTACION",
        title: "Transportación",
        icon: "mdi-bus",
        route: "/transportacion",
        type: "link",
        access: ["Admin", "ReportesCaja", "Reservas", "SuperAdmin"],
        childs: [
          {
            id: "TRANS_MANIFIESTO",
            title: "Manifiesto",
            icon: "mdi-bus",
            universal: true,
            route: "/transportacion/manifiesto/",
            type: "link",
            access: ["Admin", "ReportesCaja", "Reservas", "SuperAdmin"],
          },
        ],
      },
      {
        id: "HERRAMIENTAS",
        title: "Herramientas",
        icon: "mdi-tools",
        route: "/tools",
        type: "link",
        access: ["Admin", "Contabilidad", "SuperAdmin"],
        childs: [
          {
            id: "TOOLS_BIGQUERY_LOGGER",
            title: "Registro de Actividad",
            icon: "mdi-account-clock",
            universal: true,
            route: "/tools/logger",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "TOOLS_EXPORT_TICKETS",
            title: "Exportador de tickets",
            icon: "mdi-ticket-confirmation",
            universal: true,
            route: "/tools/export-ticket",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "TOOLS_EXPORT_TICKETS_CONTA",
            title: "Exportador de tickets",
            icon: "mdi-ticket-confirmation",
            universal: true,
            route: "/tools/export-ticketContabilidad",
            type: "link",
            access: ["Contabilidad"],
          },
          {
            id: "MIGRADOR_VENTA",
            title: "Migrador ventas",
            icon: "mdi-ticket-confirmation",
            universal: true,
            route: "/tools/migradorVentas",
            type: "link",
            access: [],
          },

          {
            id: "TOOLS_SEND_WSP",
            title: "Envio de WP",
            icon: "mdi-whatsapp",
            universal: true,
            route: "/tools/campanas-whatsapp",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "EDITOR_VENTAS",
            title: "Editor ventas",
            icon: "mdi-content-save-edit-outline",
            universal: true,
            route: "/tools/editorventas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CAMPANAS_MKT",
            title: "Campañas Cupones",
            icon: "mdi-ticket-percent",
            universal: true,
            route: "/tools/campanas-mkt",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CRON_EDITOR",
            title: "Editor Disponibilidad Productos",
            icon: "mdi-clock",
            universal: true,
            route: "/tools/cron-editor",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
        ],
      },
      {
        id: "reportes",
        title: "Reportes",
        icon: "mdi-file-document",
        route: "/reportes",
        type: "link",
        access: ["Admin", "Contabilidad", "Mayorista", "MayoristaAdmin", "AYBAdmin", "Reportes", "ReportesCaja", "Reservas", "Cajero", "SuperAdmin"],
        childs: [
          {
            id: "REPO_GENERAL",
            title: "Reporte general",
            icon: "mdi-calendar",
            universal: true,
            route: "/reportes/general",
            type: "link",
            access: ["Admin", "Reportes", "Reservas", "SuperAdmin"],
          },
          {
            id: "REPO_FINANZA",
            title: "Reportes Finanzas",
            icon: "mdi-currency-usd",
            route: "/reportes",
            type: "link",
            access: ["Admin", "Contabilidad", "AYBAdmin", "Reportes", "ReportesCaja", "Reservas", "Cajero", "SuperAdmin"],
            childs: [
              {
                id: "PDV_CAJAS",
                title: "Cierres y Aperturas",
                icon: "mdi-cash-register",
                universal: true,
                route: "/cajas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_DESCUENTOS",
                title: "Reporte Descuentos",
                icon: "mdi-currency-usd-off",
                universal: true,
                route: "/reportes/descuentos",
                type: "link",
                access: ["Admin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_PRODUCTOS_VENTAS",
                title: "Productos Vendidos",
                icon: "mdi-package",
                universal: true,
                route: "/reportes/productos_ventas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_VENTAS_POR_HORA",
                title: "Reporte por hora",
                icon: "mdi-package",
                universal: true,
                route: "/reportes/venta-productos-hora",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_PRODUCTOS_VENTAS_PROMEDIO",
                title: "Ticket promedio por producto",
                icon: "mdi-package",
                universal: true,
                route: "/reportes/producto_tprom",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_SALIDA_INSUMOS",
                title: "Salida Insumos",
                icon: "mdi-hamburger",
                universal: true,
                route: "/reportes/ventasInsumos",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_MODIFICADORES_VENTAS",
                title: "Modificadores Vendidos",
                icon: "mdi-view-list",
                universal: true,
                route: "/reportes/modificadores_ventas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "PROD_REPORTE_INV",
                title: "Rep. Existencias",
                icon: "mdi-file-document",
                universal: true,
                route: "/productos-inventarios/reporteExistencias",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "PROD_REPORTE_VAL_INV",
                title: "Valoracion de inventario",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/valoracion-inventario",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_ENTRADAS_SALIDAS",
                title: "Entradas/Salidas Manuales",
                icon: "mdi-package",
                universal: true,
                route: "/reportes/reporte-entradasysalidas",
                type: "link",
                access: ["Admin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_TRANSACCIONES",
                title: "Transacciones",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/reporte-transacciones",
                type: "link",
                access: ["Admin", "Reportes", "ReportesCaja", "Cajero", "SuperAdmin"],
              },
              {
                id: "REPO_TRANSACCIONES_CONTA",
                title: "Transacciones",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/transacionesContabilidad",
                type: "link",
                access: ["Contabilidad"],
              },
              {
                id: "REPO_PROPINAS",
                title: "Reporte de propinas",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/reporte-propinas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_VENTAS",
                title: "Ventas",
                icon: "mdi-cart",
                universal: true,
                route: "/reportes/ventas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "Cajero", "SuperAdmin"],
              },
              {
                id: "REPO_TICKET_PROMEDIO",
                title: "Ticket Promedio",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/ticket_promedio",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_VENTAS_MESERO",
                title: "Ventas por meseros",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/reporte-meseros",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_CXC",
                title: "Cuentas por cobrar",
                icon: "mdi-wallet-outline",
                universal: true,
                route: "/reportes/reporte-cxc",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_HISTORICO_CXC",
                title: "Ingresos a CXC",
                icon: "mdi-wallet-outline",
                universal: true,
                route: "/reportes/cxc-ingresos",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },
              {
                id: "REPO_MONEDEROS",
                title: "Monederos",
                icon: "mdi-wallet-outline",
                universal: true,
                route: "/reportes/monederos",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_Z",
                title: "Reporte Z",
                icon: "mdi-alpha-z",
                universal: true,
                route: "/reportes/reportez",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "Reservas", "Cajero", "SuperAdmin"],
              },
              {
                id: "REPO_Z_CONTA",
                title: "Reporte Z",
                icon: "mdi-alpha-z",
                universal: true,
                route: "/reportes/reporteZContabilidad",
                type: "link",
                access: ["Contabilidad",],
              }
            ],
          },
          {
            id: "REPO_RESERVAS_GROUPER",
            title: "Reportes Reservas",
            icon: "mdi-calendar",
            route: "/reportes",
            type: "link",
            access: ["Admin", "Mayorista", "MayoristaAdmin", "AYBAdmin", "ReportesCaja", "Reportes", "SuperAdmin"],
            childs: [
              {
                id: "REPO_RESERVAS",
                title: "Reporte de Reservas GOLF",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/reserva",
                type: "link",
                access: ["Admin", "Mayorista", "MayoristaAdmin", "ReportesCaja", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_ACTIVIDADES",
                title: "Reporte Actividades",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/actividades",
                type: "link",
                access: ["Admin", "Mayorista", "MayoristaAdmin", "ReportesCaja", "Reportes", "SuperAdmin"],
              },
              {
                id: "REPO_OCUPACION",
                title: "Reporte Ocupación",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/reporteocupacion",
                type: "link",
                access: ["Admin", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_RONDAS_PREPAGADAS",
                title: "Rondas Prepagadas",
                icon: "mdi-clock-check",
                universal: true,
                route: "/reportes/rondasprepagadas",
                type: "link",
                access: ["Admin", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPO_RONDAS",
                title: "Rondas Vendidas",
                icon: "mdi-calendar",
                universal: true,
                route: "/reportes/rondas_vendidas",
                type: "link",
                access: ["Admin", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPORTE_TARIFAS",
                title: "Reporte Tarifas",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/reportetarifas",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },

            ]
          },
          {
            id: "REPO_RESTAURANTE",
            title: "Reportes AYB",
            icon: "mdi-silverware-fork-knife",
            route: "/reportes",
            type: "link",
            access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
            childs: [
              {
                id: "REPO_TICKET_PROMEDIO",
                title: "Ticket Promedio",
                icon: "mdi-currency-usd",
                universal: true,
                route: "/reportes/ticket_promedio",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "ReportesCaja", "SuperAdmin"],
              },
              {
                id: "REPORTE_COMENSALES",
                title: "Reporte Comensales",
                icon: "mdi-account-group-outline",
                universal: true,
                route: "/reportes/comensales",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "AYB_Cuentas",
                title: "Cuentas Mesa",
                universal: true,
                icon: "mdi-silverware-fork-knife",
                route: "/restaurante/cuentas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
              {
                id: "AYB_Pagos_Propinas",
                title: "Pago de propinas",
                universal: true,
                icon: "mdi-currency-usd",
                route: "/reportes/reporte-pagos-propinas",
                type: "link",
                access: ["Admin", "AYBAdmin", "Reportes", "SuperAdmin"],
              },
            ]
          },





          /*{
            id: 'REPO_TRANSPORTACION',
            title: "Reporte de Transportación",
            icon: "mdi-bus",
            universal: true,
            route: "/reportes/transportacion",
            type: "link",
          },*/




        ],
      },
      {
        id: "configuracion",
        title: "Configuraciones",
        icon: "mdi-cogs",
        route: "/configuracion",
        type: "link",
        access: ["Admin", "ReportesCaja", "SuperAdmin"],
        childs: [
          {
            id: "CONF_GENERAL",
            title: "Configuración Departamentos",
            icon: "mdi-cash-register",
            universal: true,
            route: "/configuracion/general",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CONF_ACCESOS",
            title: "Accesos",
            icon: "mdi-key",
            route: "/configuracion",
            type: "link",
            access: ["Admin", "SuperAdmin"],
            childs: [
              {
                id: "CONF_ZONAS_SEGURIDAD",
                title: "Zonas de Seguridad",
                icon: "mdi-shield-home",
                universal: true,
                route: "/configuracion/zonas-seguridad",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },
              {
                id: "CONF_PUERTAS_ACCESO",
                title: "Puertas de Acceso",
                icon: "mdi-door-closed-lock",
                universal: true,
                route: "/configuracion/puertas-acceso",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },
            ],
          },
          {
            id: "CONF_METODOSPAGO",
            title: "Metodos Pago",
            icon: "mdi-credit-card-plus-outline",
            universal: true,
            route: "/configuracion/metodos_pago",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CONF_ZONAIMP",
            title: "Zonas de impresión",
            icon: "mdi-printer",
            universal: true,
            route: "/zonas-impresion",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CONF_RVA",
            title: "Configuración Reservas",
            icon: "mdi-calendar",
            universal: true,
            route: "/configuracion/reservas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          /*{
            id: "CONF_ROLES",
            title: "Roles",
            icon: "mdi-script-text",
            universal: true,
            route: "/configuracion/roles",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },*/
          {
            id: "CONF_TIPO_CAMBIO",
            title: "Tipos de Cambio",
            icon: "mdi-currency-usd",
            universal: true,
            route: "/configuracion/tiposcambios",
            type: "link",
            access: ["Admin", "ReportesCaja", "SuperAdmin"],
          },
          {
            id: "CONF_ACTIVIDADES",
            title: "Actividades",
            icon: "mdi-cogs",
            route: "/configuracion",
            type: "link",
            access: ["Admin", "SuperAdmin"],
            childs: [
              {
                id: "CONF_CREADOR_ACTIVIDADES",
                title: "Creador Actividades",
                icon: "mdi-pencil-outline",
                universal: true,
                route: "/configuracion/creador_actividades",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },
              {
                id: "CONF_BAHIA",
                title: "Bahias de actividades",
                icon: "mdi-view-list",
                universal: true,
                route: "/configuracion/bahias",
                type: "link",
                access: ["Admin", "SuperAdmin"],
              },
            ],
          },
          {
            id: "CONF_BIOMETRICO",
            title: "Dispositivos Biometricos",
            icon: "mdi-fingerprint",
            universal: true,
            route: "/configuracion/dispositivos-biometricos",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CONF_DIAS",
            title: "Cierre/Apertura del Campo",
            icon: "mdi-calendar",
            universal: true,
            route: "/configuracion/dias",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          {
            id: "CONF_HORAS",
            title: "Bloqueo de Tee Times",
            icon: "mdi-alarm",
            universal: true,
            route: "/configuracion/horas",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },
          /*{
            id: "CONF_SMTP",
            title: "SMTP",
            icon: "mdi-email",
            universal: true,
            route: "/configuracion/smtp",
            type: "link",
            access: ["Admin", "SuperAdmin"],
          },*/
        ],
      },
      {
        id: "Documentacion",
        title: "Documentacion",
        icon: "mdi-file-document-edit-outline",
        universal: true,
        route: "/documentacion/",
        type: "link",
        access: ["ALL", "SuperAdmin"],
      },
      /*{
        id: 'reservar_transportacion',
        title: "Reservar Transportación",
        icon: "mdi-bus",
        universal: true,
        route: 'resTransportacion',
        click: () => {
          //self.openTab();
        },
        type: "custom",
      },*/
      {
        id: "logout",
        title: "Cerrar Sesión",
        icon: "mdi-logout",
        route: "logout",
        public: true,
        access: ["ALL", "SuperAdmin"],
        click: () => {
          //self.logout();
        },
        type: "custom",
      },
    ];

    let menuByRol = [];
    let pgsHelper = new PGSHelper();

    menu.forEach((menuItem) => {
      if (menuItem.type != "divider") {
        if (
          menuItem.access.includes(typeUser) ||
          menuItem.access.includes("ALL")
        ) {
          let item = this.getChildsAllowed(
            pgsHelper.cloneObj(menuItem),
            typeUser
          );
          if (item) {
            menuByRol.push(item);
          }
        }
      } else {
        menuByRol.push(menuItem);
      }
    });
    return menuByRol;
  }

  getChildsAllowed(menuItem, typeUser) {
    const tenant = localStorage.getItem('ParGolfTenant')
    if (menuItem.access) {
      if (
        menuItem.access.includes(typeUser) ||
        menuItem.access.includes("ALL") ||
        (menuItem.id == "MIGRADOR_VENTA" & tenant == "BOKA")
      ) {
        let item = menuItem;
        if (item.childs) {
          let childs = [];
          item.childs.forEach((child) => {
            childs = childs.concat(this.getChildsAllowed(child, typeUser));
          });
          item.childs = childs;
          return item;
        } else {
          if (menuItem.id == "AYB_Pagos_Propinas" & tenant != "BOKA") {
            return [];
          } else if (menuItem.id == "TOOLS_SEND_WSP" && tenant != "BOKA" && tenant != "TEST") {
            return [];
          } else {
            return item;
          }

        }
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  getMenuAsRow(childs = false, role = "Admin", permissions = []) {
    let pgsHelper = new PGSHelper();
    let rowMenu = [];
    let menu = childs ? childs : this.getMenu();
    let permiso = permissions;
    if (role == "Mayorista") {
      permiso = [
        { id: "golf_booking", C: true, R: true, U: true, D: true },
        { id: "list_reserva", C: true, R: true, U: true, D: true },
      ];
    }
    menu.forEach((item) => {
      if (role == "Admin") {
        item.C = true;
        item.R = true;
        item.U = true;
        item.D = true;
      } else {
        if (pgsHelper.getById(permiso, "id", item.id)) {
          let permisoData = pgsHelper.getById(permiso, "id", item.id);
          item.C = permisoData.C;
          item.R = permisoData.R;
          item.U = permisoData.U;
          item.D = permisoData.D;
        } else {
          item.C = false;
          item.R = false;
          item.U = false;
          item.D = false;
        }
      }

      if (!item.childs) {
        rowMenu.push(item);
      } else {
        rowMenu.push(item);
        rowMenu = rowMenu.concat(this.getMenuAsRow(item.childs, role));
      }
    });
    return rowMenu;
  }

  // regresa los permisos globales de la base de datos
  getGlobalPermissions() {
    let permisos = store.getters.getGPermisos;
    let arr = [];

    Object.entries(permisos).map((item) => {
      let permisoData = { id: item[0], ...item[1] }; // objeto del permiso

      if (permisoData.Dptos) {
        //si tiene departamentos
        let departamentos = [];
        if (permisoData.id.split("_")[0] == "RVA") {
          departamentos = store.getters.getDepartamentos;
        } else if (permisoData.id.split("_")[0] == "PDV") {
          departamentos = store.getters.getPDVDepartamentos;
        }
        permisoData.PermisosDpto = this.buildPermissionsByDepartment(
          departamentos,
          permisoData.Pmsos
        );
      } else {
        // si no tiene departamento usamos el universal
        let departamentos = [{ id: "UNI__", Nombre: "Global" }];
        permisoData.PermisosDpto = this.buildPermissionsByDepartment(
          departamentos,
          permisoData.Pmsos
        );
      }
      arr.push(permisoData);
    });

    return arr;
  }
  // parsea los datos de los departamentos y permisos a estructura de arrays para mostrar Form
  buildPermissionsByDepartment(Departamentos, Permisos) {
    // objeto de permisos
    let PermisosDpto = [];

    Departamentos.forEach((departamento) => {
      let pmsos = [];
      Permisos?.forEach((pms) => {
        pmsos.push({
          code: pms,
          id: pms.split("_")[1],
          Nombre: pms.split("_")[0],
          value: false,
        });
      });
      PermisosDpto.push({
        deptId: departamento.id,
        deptoNombre: departamento.Nombre,
        Permisos: pmsos,
      });
    });

    return PermisosDpto;
  }
  //Parsea la informacion del formulario de permisos a formato para enviar al servidor
  PermissionDataFormToServer(dataPermission) {
    let data = {};
    dataPermission.forEach((permiso) => {
      let departamento = {};
      permiso.PermisosDpto.forEach((Departamento) => {
        let permiso = [];
        Departamento.Permisos.forEach((Permiso) => {
          if (Permiso.value) {
            permiso.push(Permiso.id);
          }
        });
        departamento[Departamento.deptId] = permiso;
      });
      data[permiso.id] = departamento;
    });
    return data;
  }

  PermissionServerToDataForm(rolsData, patchData) {
    let global = this.getGlobalPermissions();
    let permissions = this.MergePermissions(rolsData, patchData);

    global.forEach((gPermission) => {
      gPermission.PermisosDpto.forEach((departamento) => {
        departamento.Permisos.forEach((permiso) => {
          permiso.value = this.validatePermission(
            permissions,
            gPermission.id,
            departamento.deptId,
            permiso.id
          );
        });
      });
    });

    return global;
  }

  validatePermission(permissionData, permission, departamento, code) {
    let exist = false;
    if (permissionData[permission]) {
      if (permissionData[permission][departamento]) {
        exist = permissionData[permission][departamento].includes(code);
      }
    }
    return exist;
  }
  //Mergea un bloque de permisos en formato servidor y devuelve el objeto final de permisos
  MergePermissions(block, patch) {
    let Permisos = this.PermissionDataFormToServer(this.getGlobalPermissions());
    Object.entries(Permisos).forEach((perm) => {
      let idPermiso = perm[0];
      let Departamentos = perm[1];
      Object.entries(Departamentos).forEach((dept) => {
        let idDepartamento = dept[0];
        Permisos[idPermiso][idDepartamento] = this.MergeArrayPermisos(
          idPermiso,
          idDepartamento,
          block,
          patch
        );
      });
    });

    return Permisos;
  }
  //Verifica el mergeo de permisos y el parche para devolver un unico array
  MergeArrayPermisos(permiso, departamento, block, patch) {
    let mergedArray = [];
    block.forEach((rol) => {
      if (rol[permiso]) {
        mergedArray = mergedArray.concat(
          rol[permiso][departamento].filter(
            (item) => mergedArray.indexOf(item) < 0
          )
        );
        if (patch[permiso]) {
          if (patch[permiso][departamento]) {
            mergedArray = patch[permiso][departamento];
          }
        }
      }
    });
    return mergedArray;
  }
  //Obtiene los permisos de la bd segun el typo = "role","user"
  getPermissionsByType(rolsData, patchData) {
    let permisos = this.MergePermissions(this.roleBlock, this.patch);
    return permisos;
  }
}
